export { default as Root } from './Collapsible';
export type { CollapsibleProps } from './Collapsible';

export { default as Trigger } from './Trigger';
export type { CollapsibleTriggerProps } from './Trigger';

export { default as Content } from './Content';
export type { CollapsibleContentProps } from './Content';
